export const appHead = {"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1,  maximum-scale=1"},{"hid":"description","name":"description","content":"Генерация школьных, курсовых, дипломных работ и индивидуальных проектов с помощью нейронной сети. Цели, задачи, содержание из 10 разделов уникального текста, список литературы, экспорт в Word."},{"hid":"keywords","name":"keywords","content":"нейросеть для написания проекта, нейросеть для создания проекта, нейросеть пишет проект, написать проект с помощью нейросети, нейросеть для написания проектов, нейросеть написать проект, нейросеть придумывает цели"},{"property":"og:title","content":"Нейросеть для проектов – Бегемот"},{"property":"og:description","content":"Генерация школьных, курсовых, дипломных работ и индивидуальных проектов с помощью нейронной сети. Цели, задачи, содержание из 10 разделов уникального текста, список литературы, экспорт в Word."},{"property":"og:type","content":"website"},{"property":"og:site_name","content":"Нейросеть для проектов – Бегемот"},{"property":"og:url","content":"https://begemot.ai/"},{"name":"theme-color","content":"#ffffff"}],"link":[{"rel":"icon","type":"image/x-icon","href":"/favicon.ico"},{"rel":"icon","type":"image/svg+xml","href":"/favicon.svg"},{"rel":"apple-touch-icon","type":"image/svg+xml","href":"/favicon.svg"}],"style":[],"script":[{"defer":true,"src":"https://yastatic.net/s3/passport-sdk/autofill/v1/sdk-suggest-with-polyfills-latest.js"}],"noscript":[],"htmlAttrs":{"prefix":"og: https://ogp.me/ns#","lang":"ru"},"title":"Нейросеть для проектов – Бегемот","viewport":"width=device-width, initial-scale=1, maximum-scale=1"}

export const appPageTransition = {"name":"page","mode":"out-in"}

export const appRootAttrs = {"id":"__nuxt","lang":"ru"}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink"}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000